import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useSessionStorage } from 'react-use';

const GTM_DEBUG_QUERY_PARAM = 'gtm-debug';
const GTM_DEBUG_SESSION_KEY = 'pd-debug-gtm';

const useGtmDebugger = (): boolean => {
  const { query } = useRouter();
  const paramValue = query[GTM_DEBUG_QUERY_PARAM];

  const shouldEnableDebugger = typeof paramValue === 'string' && paramValue !== 'false';

  const [isGtmDebuggerEnabled, setIsGtmDebuggerEnabled] = useSessionStorage<boolean | null>(
    GTM_DEBUG_SESSION_KEY,
    shouldEnableDebugger
  );

  useEffect(() => {
    if (typeof paramValue !== 'string') {
      return;
    }

    if (paramValue === 'false') {
      setIsGtmDebuggerEnabled(null);
      return;
    }

    setIsGtmDebuggerEnabled(true);
  }, [paramValue]);

  return Boolean(isGtmDebuggerEnabled);
};

export default useGtmDebugger;
